import styled from 'styled-components';

export const Attribute = styled.div`
  display: grid;
  grid-template-rows: 30px 1fr;
`;
export const Label = styled.div`
  padding: 5px 0px 0px 5px;
  font-size: min(1vw, 2em);
`;
export const Value = styled.div`
  font-size: min(2vw, 3em);
  text-align: center;
`;
